import type { Vector3Tuple } from '../types';

export interface TimeOfDayOption {
  id: string;
  name: string;
  description: string;
  icon: string;
  ambientMultiplier: number;
  directMultiplier: number;
  environmentMultiplier: number;
  backgroundMultiplier: number;
  sunColor: string;
  sunPosition: Vector3Tuple;
  skyColor: string;
  isDark: boolean;
}

export const TIME_OF_DAY_IDS = {
  DAY: 'day',
  SUNSET: 'sunset',
  NIGHT: 'night',
} as const;

export const timeOfDayOptions: readonly TimeOfDayOption[] = [
  {
    id: TIME_OF_DAY_IDS.DAY,
    name: '낮',
    description: '선명한 자연광',
    icon: '☀',
    ambientMultiplier: 1,
    directMultiplier: 1,
    environmentMultiplier: 1,
    backgroundMultiplier: 1,
    sunColor: '#fff8e8',
    sunPosition: [18, 28, -12],
    skyColor: '#87b5d6',
    isDark: false,
  },
  {
    id: TIME_OF_DAY_IDS.SUNSET,
    name: '일몰',
    description: '낮은 태양과 따뜻한 광원',
    icon: '◒',
    ambientMultiplier: 0.68,
    directMultiplier: 0.82,
    environmentMultiplier: 0.7,
    backgroundMultiplier: 0.72,
    sunColor: '#ff9a5a',
    sunPosition: [26, 6, -18],
    skyColor: '#c26758',
    isDark: false,
  },
  {
    id: TIME_OF_DAY_IDS.NIGHT,
    name: '밤',
    description: '어두운 하늘 · 헤드라이트 자동 점등',
    icon: '☾',
    ambientMultiplier: 0.2,
    directMultiplier: 0.12,
    environmentMultiplier: 0.2,
    backgroundMultiplier: 0,
    sunColor: '#91adff',
    sunPosition: [-12, 18, 24],
    skyColor: '#07101f',
    isDark: true,
  },
];

export const DEFAULT_TIME_OF_DAY_ID = TIME_OF_DAY_IDS.DAY;

export function findTimeOfDayById(id: string): TimeOfDayOption | undefined {
  return timeOfDayOptions.find((option) => option.id === id);
}
